export enum AnswerFormatType {
  Text = 'text',
  Image = 'image',
  TextWithImage = 'text_image',
}
